import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { hospitalInfo } from "../content/hospitalContent";
import logo from "../assets/logo.png";
import { FiMail, FiMapPin, FiFacebook, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";
// Added FaXTwitter here
import { FaKitMedical, FaUser, FaCalendarPlus, FaXTwitter } from "react-icons/fa6";
import { MdOutlineArrowOutward } from "react-icons/md";

export default function Footer() {
  const appContext = useContext(AppContext);

  const navLinks = [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about_us" },
    { label: "Careers", item: "careers" },
    { label: "Services", item: "services" },
    { label: "Contact", item: "contact_us" },
  ];

  return (
    <>
      
      <footer className="med-footer">
        <div className="container-fluid px-5">
          <div className="med-footer-grid">
            
            {/* 1. Brand Identity */}
            <div className="med-footer-brand">
              <img src={logo} alt="Logo" />
              <h5 className="fw-bold mb-2">{hospitalInfo.name}</h5>
              <p className="med-footer-tagline">{hospitalInfo.tagline}</p>
              
              <div className="footer-social-wrapper">
                <a href="#" className="social-icon-link"><FiFacebook /></a>
                <a href="#" className="social-icon-link"><FiInstagram /></a>
                {/* Updated to FaXTwitter */}
                <a href="#" className="social-icon-link"><FaXTwitter /></a>
                <a href="#" className="social-icon-link"><FiYoutube /></a>
              </div>
            </div>

            {/* 2. Navigation */}
            <div>
              <span className="med-footer-label">Navigation</span>
              <ul className="med-footer-list">
                {navLinks.map(link => (
                  <li key={link.item}>
                    <button onClick={() => appContext.navTo({ item: link.item })} className="med-footer-link">
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* 3. Contact Info */}
            <div>
              <span className="med-footer-label">Contact</span>
              <ul className="med-footer-list">
                <li><a href={hospitalInfo.emailLink} className="med-footer-link"><FiMail /> {hospitalInfo.email}</a></li>
                <li><a href={hospitalInfo.emailLink2} className="med-footer-link"><FiMail /> {hospitalInfo.email2}</a></li>
                <li>
                  <a 
                    href={`https://maps.app.goo.gl/F54E4TFQy9iWrmXJ6`} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="med-footer-link"
                  >
                    <FiMapPin /> Dodoma, Tanzania
                  </a>
                </li>
              </ul>
            </div>

            {/* 4. Access Portals */}
            <div>
              <span className="med-footer-label">Access</span>
              <div className="d-flex flex-column gap-2">
                <a href={hospitalInfo.patientUrl} target="_blank" rel="noreferrer" className="btn-medical-outline">
                  <div className="btn-content-gap">
                    <FaKitMedical size={16} /> 
                    <span>Patient Portal</span>
                  </div>
                  <MdOutlineArrowOutward size={18} className="ms-auto" />
                </a>

                <a href={hospitalInfo.staffUrl} target="_blank" rel="noreferrer" className="btn-medical-outline">
                  <div className="btn-content-gap">
                    <FaUser size={16} /> 
                    <span>Staff Portal</span>
                  </div>
                  <MdOutlineArrowOutward size={18} className="ms-auto" />
                </a>

                <a href={hospitalInfo.scheduleUrl} target="_blank" rel="noreferrer" className="btn-medical-outline">
                  <div className="btn-content-gap">
                    <FaCalendarPlus size={16} /> 
                    <span>Schedule An Appointment</span>
                  </div>
                  <MdOutlineArrowOutward size={18} className="ms-auto" />
                </a>
              </div>
            </div>

          </div>

          <div className="med-footer-bottom text-center">
            <p className="mb-0 text-center">© {getCurrentYear()} Nanguba Healthcare.</p>
            <div className="">
              Website Designed By <a href="https://werenium.com" target="_blank" rel="noreferrer" className="text-decoration-none text-reset fw-bold">Werenium Technologies</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}